<script setup lang="ts">
import type { ModelRef } from "vue";
import { countryFavorites, countryList } from "~/core/constants/country";
import type { Country } from "~/core/models/Country.interface";

defineProps<{
  disabled?: boolean;
}>();

const { t } = useI18n();

const country: ModelRef<string | undefined> = defineModel<string>();

const countriesSorted: Country[] = sortCountriesWithFavorites(
  countryList,
  countryFavorites,
);

function getCountryLabel(countryItem: string): string {
  return t("administration.country." + countryItem);
}

function sortCountriesWithFavorites(
  countries: string[],
  favoriteCodes: string[],
): Country[] {
  return countries
    .map((country: string) => {
      return {
        code: country,
        favorite: favoriteCodes.includes(country),
        name: getCountryLabel(country),
      };
    })
    .sort((a, b) => {
      if (a.favorite === b.favorite) return 0;
      return a.favorite ? -1 : 1;
    });
}
</script>
<template>
  <lxc-select
    v-model="country"
    :placeholder="t('administration.entityLocation.countryPlaceholder')"
    :disabled="disabled"
    select-filter
    :select-search-placeholder="
      t('administration.entityLocation.countrySearchPlaceholder')
    "
    :select-no-result-text="t('input.select.search.noResults')"
  >
    <lxc-option
      v-for="(countryItem, index) in countriesSorted"
      :key="index"
      :label="countryItem.name"
      :value="countryItem.code"
      :title="countryItem.name"
    >
      <div class="flex justify-between w-full">
        <span class="text-gray-900">{{ countryItem.name }}</span>
        <span v-if="countryItem.favorite" class="text-gray-500">{{
          t("administration.entityLocation.countryPopular")
        }}</span>
      </div>
    </lxc-option>
  </lxc-select>
</template>
